import styled from 'styled-components';

import { moderateScale } from '../../../../../../utils/scaleHelpers';

export const StyledVideo = styled.video`
  display: block;
  margin: ${moderateScale(30)}px auto;
`;
